import { combineReducers } from "redux";

import auth from "./auth";
import challenges from "./challenges";
import entry from "./entry";
import messages from "./messages";
import organisations from "./organisations";
import user from "./user";

const reducers = combineReducers({
  auth,
  user,
  messages,
  organisations,
  challenges,
  entry,
});

export default reducers;
